var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentsViewEntries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ccc;}.cls-2{fill:#00a0df;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "appointments_view_entries"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.3,60.21C31.65,60.21,2,86.93,2,119.89V537.65c0,33,29.7,59.68,66.35,59.68H532.79c36.66,0,66.35-26.7,66.35-59.68V119.89c0-33-29.69-59.68-66.35-59.68H68.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.3,60.21C31.65,60.21,2,87.07,2,119.89v89.52H599.14V119.89c0-32.82-29.69-59.68-66.35-59.68H68.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.42.53A29.84,29.84,0,0,0,79.58,30.37v89.52a29.84,29.84,0,1,0,59.68,0V30.37A29.84,29.84,0,0,0,109.42.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M483.46.53c-16.47,0-29.84,11.94-29.84,29.84v89.52c0,14.92,13.37,29.84,29.84,29.84s29.84-14.92,29.84-29.84V30.37C513.3,12.47,499.93.53,483.46.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.66,284.58v59.78a27.81,27.81,0,0,0,27.82,27.81h59.78a27.81,27.81,0,0,0,27.81-27.81V284.58a27.82,27.82,0,0,0-27.81-27.82H96.48A27.82,27.82,0,0,0,68.66,284.58Zm173.12,0v59.78a27.81,27.81,0,0,0,27.81,27.81h59.78a27.81,27.81,0,0,0,27.82-27.81V284.58a27.82,27.82,0,0,0-27.82-27.82H269.59A27.82,27.82,0,0,0,241.78,284.58Zm173.12,0v59.78a27.81,27.81,0,0,0,27.81,27.81h59.78a27.82,27.82,0,0,0,27.82-27.81V284.58a27.83,27.83,0,0,0-27.82-27.82H442.71A27.82,27.82,0,0,0,414.9,284.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.66,457.69v59.79a27.81,27.81,0,0,0,27.82,27.81h59.78a27.81,27.81,0,0,0,27.81-27.81V457.69a27.81,27.81,0,0,0-27.81-27.81H96.48A27.81,27.81,0,0,0,68.66,457.69Zm173.12,0v59.79a27.81,27.81,0,0,0,27.81,27.81h59.78a27.81,27.81,0,0,0,27.82-27.81V457.69a27.81,27.81,0,0,0-27.82-27.81H269.59A27.81,27.81,0,0,0,241.78,457.69Zm173.12,0v59.79a27.81,27.81,0,0,0,27.81,27.81h59.78a27.82,27.82,0,0,0,27.82-27.81V457.69a27.82,27.82,0,0,0-27.82-27.81H442.71A27.81,27.81,0,0,0,414.9,457.69Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentsViewEntries);
export default __webpack_public_path__ + "static/media/appointments_view_entries.33c59bfba98dc9c7691dbb2c3cc81c44.svg";
export { ForwardRef as ReactComponent };